// extracted by extract-css-chunks-webpack-plugin
module.exports = {"activity":"activity_OEcwX","title":"title_1twzm"};